module.exports = __webpack_public_path__ + "img/wallet-hard-en.a482af22.png";